import React, { useMemo } from 'react';
import Badge from '../../../components/ui/Badge';
import { ReferenceDataGeneralList, type ReferenceInboxColumn } from '../ReferenceDataGeneralList';
import { moduleConfig } from './config';
import { useManagementCompanies, type ManagementCompany } from './useData';
import { ManagementCompanyLogoPanel } from './LogoPanel';

const List: React.FC = () => {
  const formatDate = moduleConfig.utils.formatDate;
  const columns = useMemo<ReferenceInboxColumn<ManagementCompany>[]>(
    () => [
      {
        key: 'logo',
        header: 'Logo',
        className: 'w-12',
        render: (row) => (
          <ManagementCompanyLogoPanel
            companyId={row.id}
            logoStorageKey={row.logoStorageKey}
            compact
            editable={false}
          />
        ),
      },
      {
        key: 'code',
        header: 'Code',
        className: 'whitespace-nowrap',
        render: (row) => (
          <span className="font-medium font-mono text-xs tracking-wide">{row.code}</span>
        ),
      },
      {
        key: 'name',
        header: 'Name',
        render: (row) => row.name,
      },
      {
        key: 'isActive',
        header: 'Active',
        className: 'whitespace-nowrap',
        render: (row) => (
          <Badge variant={row.isActive ? 'success' : 'danger'}>{row.isActive ? 'Yes' : 'No'}</Badge>
        ),
      },
      {
        key: 'sortOrder',
        header: 'Order',
        className: 'hidden whitespace-nowrap md:table-cell',
        render: (row) => row.sortOrder,
      },
      {
        key: 'createdAt',
        header: 'Created',
        className: 'hidden whitespace-nowrap lg:table-cell',
        render: (row) => formatDate(row.createdAt),
      },
    ],
    [formatDate],
  );

  return (
    <ReferenceDataGeneralList
      moduleConfig={moduleConfig}
      useData={useManagementCompanies}
      columns={columns}
      defaultSort={{ key: 'code', direction: 'asc' }}
      newLabel="New management company"
      getRowLabel={(row) => row.name}
    />
  );
};

export default List;
